import { render, staticRenderFns } from "./Personal.vue?vue&type=template&id=004c564e&scoped=true&"
import script from "./Personal.vue?vue&type=script&lang=js&"
export * from "./Personal.vue?vue&type=script&lang=js&"
import style0 from "./Personal.vue?vue&type=style&index=0&id=004c564e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "004c564e",
  null
  
)

export default component.exports